import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { find, groupBy, some } from 'lodash-es';
import { map, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import {
  EventDetailsRequestData,
  EventDetailsResponseData,
  SessionStatusEnum,
  SessionTypeEnum,
} from './event-agenda.data-model';

@Injectable({
  providedIn: 'root',
})
export class EventAgendaDataService {
  private readonly _http = inject(HttpClient);
  private readonly _apiUrl = environment.apiUrl;

  getEventDetails(
    requestData: EventDetailsRequestData
  ): Observable<EventDetailsResponseData> {
    return this._http
      .post<EventDetailsResponseData>(
        this._apiUrl + '/r1/getEventDetails',
        requestData
      )
      .pipe(
        // TODO: @later remove this once the API has provided a nice solution to fetch without breakout sessions and the live primary session statuses are handled
        map((response) => {
          const sessions = response.data;
          const sessionsByPrimaryId = groupBy(sessions, 'PrimarySessionId');
          Object.values(sessionsByPrimaryId).forEach((group) => {
            const primarySession = find(group, {
              Type: SessionTypeEnum.PrimarySession,
            });
            if (primarySession) {
              primarySession.hasBreakoutSessions = some(sessions, {
                Type: SessionTypeEnum.BreakoutSession,
              });
              const hasInProgressOrPausedBreakout = some(
                group,
                (session) =>
                  session.Type === SessionTypeEnum.BreakoutSession &&
                  (session.Status === SessionStatusEnum.InProgress ||
                    session.Status === SessionStatusEnum.Paused)
              );
              if (hasInProgressOrPausedBreakout) {
                primarySession.Status = SessionStatusEnum.InProgress;
              }
            }
          });
          response.data = sessions.filter(
            (event) => event?.Type !== SessionTypeEnum.BreakoutSession
          );
          return response;
        })
      );
  }
}
